export default "__VITE_ASSET__327e2d97__"